import PaymentMethodPopup from "./PaymentMethodPopup";
export default PaymentMethodPopup;



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/PaymentManagementCard/PaymentMethodPopup/index.js